import { render, staticRenderFns } from "./PortalCustomersList.vue?vue&type=template&id=6b9f53a9&scoped=true&"
import script from "./PortalCustomersList.vue?vue&type=script&lang=ts&"
export * from "./PortalCustomersList.vue?vue&type=script&lang=ts&"
import style0 from "./PortalCustomersList.vue?vue&type=style&index=0&id=6b9f53a9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f53a9",
  null
  
)

export default component.exports